<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card v-if="!registered" class="elevation-12 primary white--text">
							<v-toolbar-title>
								<v-img
									class="mx-auto mt-5"
									alt="Orixe Logo"
									:src="require('../../assets/Logo_Header_White.svg')"
									width="40%"
								/>
								<h2 class="mt-2 ml-5 white--text text-center">
									Welcome to Orixe!
								</h2>
								<v-card-text class=" text-center"
									><p>
										Please enter your company's name and your e-mail to join!
									</p></v-card-text
								>
							</v-toolbar-title>
							<v-form @submit.prevent="register" v-model="valid">
								<v-card-text>
									<v-text-field
										label="Company Name"
										v-model="name"
										name="login"
										append-icon="fas fa-user"
										type="text"
										:rules="[
											v => {
												return !!v || 'This field is required.'
											}
										]"
										dark
									></v-text-field>
									<br />
									<v-text-field
										id="email"
										label="E-mail"
										name="email"
										append-icon="fas fa-key"
										type="text"
										:rules="[
											v => {
												return !!v || 'This field is required.'
											}
										]"
										v-model="email"
										dark
									></v-text-field>
								</v-card-text>
								<v-card-actions>
									<p>Already have an account?<br>Go to <router-link class="white--text" to = "/login">orixe.tech/login</router-link></p>
									<v-spacer></v-spacer>
									<v-btn :disabled="!valid" type="submit" color="white" outlined
										>Create Account</v-btn
									>
								</v-card-actions>
							</v-form>
						</v-card>

						<v-card v-else class="elevation-12 primary white--text">
							<v-toolbar-title>
								<v-img
									class="mx-auto mt-5"
									alt="Orixe Logo"
									:src="require('../../assets/Logo_Header_White.svg')"
									width="40%"
								/>
								<h2 class="mt-2 ml-5 white--text text-center">
									You are now registered!
								</h2>
							</v-toolbar-title>
							<v-card-text class="white--text text-center">
								<p>Thank you for joining Orixe! Check your e-mail for your login details! You should receive it after a few minutes!</p>
								<p><b>Didn't get an e-mail?</b> Check your spam folder!</p>
								<p><b>Still can't find it?</b> Contact us at <a href="mailto:support@orixe.se" class="white--text">support@orixe.se</a></p>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>

		<test-error />
	</v-app>
</template>

<script>
import BillingAPI from "../../api/billing"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "Register",

	data() {
		return {
			name: null,
			email: null,
			valid: false,
			registered: false
		}
	},
	mounted() {},
	methods: {
		register() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			BillingAPI.join(this.name, this.email)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.setRegistered()
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		setRegistered() {
			this.registered = true
		}
	}
}
</script>
